import { Plugin } from 'prosemirror-state';

import { EditorOptions } from '@lyearn/lygo-core';

import BlankNodeView from './NodeView';

function plugins({ createReactNodeView }: EditorOptions) {
  return [
    new Plugin({
      props: {
        nodeViews: {
          blank(node, view, getPos, decorations) {
            return createReactNodeView({
              node,
              view,
              getPos,
              decorations,
              component: BlankNodeView,
              inline: true,
              stopDomEvents: true,
            });
          },
        },
      },
    }),
  ];
}

export default plugins;
